import { useState } from "react";
import InfluencerCircles from "../../components/InfluencersCircles";
import DietitiansFilter from "./DietitiansFilter";
import FAQ from "./FAQ";
import ShortSessions from "./ShortSession";
import ShortConsultationSection from "../main/ShortConsultationSection";
import Container from "../../components/Container";

const FindDietitian = () => {
  const sortByInfo = {
    "sort-by": "Sort by",
    "top-reviews": "Top reviews",
    "highest-price": "Highest price",
    "lowest-price": "Lowest price",
    "most-recent": "Most recent",
  };
  const [activeListbox, setActiveListbox] = useState(null);
  const [sortBy, setSortBy] = useState("sort-by");
  const [sortByText, setSortByText] = useState(sortByInfo[sortBy]);

  const handleSortType = (sortBy) => {
    setSortBy(sortBy);
    setSortByText(sortByInfo[sortBy]);
    setActiveListbox(null);
  };
  const handleClick = (listboxIndex) => {
    setActiveListbox(
      activeListbox !== null && listboxIndex === activeListbox
        ? null
        : listboxIndex
    );
  };

  return (
    <>
      <section className="border-y xs:hidden md:block">
        <Container padding={"p-0"}>
          <DietitiansFilter
            handleClick={handleClick}
            activeListbox={activeListbox}
          />
        </Container>
      </section>
      <section className="border-y bg-white">
        <Container padding={"p-0"} width="w-full" maxWidth={"max-w-full"}>
          <ShortSessions
            handleClick={handleClick}
            activeListbox={activeListbox}
            handleSortType={handleSortType}
            sortBy={sortBy}
            sortByText={sortByText}
          />
        </Container>
      </section>
      <section className="bg-white">
        <Container>
          <FAQ />
        </Container>
      </section>
      <section className="">
        <Container>
          <InfluencerCircles />
        </Container>
      </section>
      <section className="bg-white overflow-hidden">
        <Container
          maxWidth={
            "xs:max-w-full md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]"
          }
          width={"w-full"}
        >
          <ShortConsultationSection />
        </Container>
      </section>
    </>
  );
};

export default FindDietitian;
